const BLACKLIST = [
  'isActive',
  'isSelected',
  'gridColumnGap',
  'isMobile',
  'useBackgroundImage',
  'url',
  'isShortened',
  'textAlignment',
  'hasFocalPoint',
  'focalPoint',
  'textColor',
  'backgroundColor',
  'isReverse',
  'ratingBy',
];
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'prop' implicitly has an 'any' type.
export const shouldForwardProp = (prop) => {
  return !BLACKLIST.includes(prop);
};
